<template>
  <div class="product-search-component w-100">
      <div v-if="selectedProduct">
          <BaseInput
            disabled
            fullWidth
            leftIcon="link"
            icon="link"
            rightIcon="x"
            iconPosition="both"
            rightIconColor="red-3"
            @iconClicked="resetSelection"
            :value="`${selectedProduct.name} (${selectedProduct.category})`"/>
      </div>
      <div class="search-container" v-else>
          <BaseInput
            v-model="search"
            fullWidth
            :placeholder="placeholder || $t('recommendations.search_input')"
            icon="search"/>

            <div class="search-results" v-if="searchResults && searchResults.length">
                <div
                    class="search-result qrw-paragraph-md"
                    v-for="(result,index) in searchResults"
                    :key="index"
                    @click="onResultSelect(result)">
                    {{ result.name }} ({{ result.category }}, {{ result.menu_title }})
                </div>
            </div>
      </div>
  </div>
</template>

<script>
export default {
    props: {
        value: Object,
        placeholder: String
    },
    data() {
        return {
            search: null
        }
    },
    methods: {
        onResultSelect(result) {
            this.$emit('input', {
                menu_id: result.menu_id,
                product_id: result._id
            });
            this.search = null;
        },
        resetSelection() {
            this.$emit('clear');
            this.search = null;
        }
    },
    computed: {
        selectedProduct() {
            if (!this.value || !this.value.product_id || !this.value.menu_id) {
                return null;
            }

            return this.$store.getters['menu/findGlobalProduct'](
                this.value.menu_id,
                this.value.product_id
            );
        },
        allProducts() {
            return this.$store.state.menu.menus.reduce((acc, menu) => {
                return acc.concat(
                    menu.products.map(p => ({
                        ...p,
                        menu_id: menu._id,
                        menu_title: menu.title
                    }))
                );
            }, []);
        },
        searchResults() {
            if (!this.search) return [];

            const q = this.search.toLowerCase();

            if (q.length < 3) return [];

            return this.allProducts.filter(p => {
                return (p.name && p.name.toLowerCase().includes(q)) || (p.category && p.category.toLowerCase().includes(q));
            });
        }
    }
}
</script>

<style scoped>
.search-container {
    position: relative;
}

.search-results {
    position: absolute;
    z-index: 5;

    top: 32px;
    left: 0;

    width: 100%;

    max-height: 300px;
    overflow-y: auto;
}

.search-result {
    width: 100%;
    background: var(--v1-grey-3-color);
    color: var(--v1-grey-8-color);
    padding: 8px;
    cursor: pointer;
    box-sizing: border-box;
    border-top: 1px solid var(--v1-grey-7-color);
}

.search-result:hover {
    color: var(--v1-grey-10-color);
}
</style>
